module.exports = __webpack_public_path__ + "static/media/charlesCassidyEnrollment.3f06b22f.png";